import {Injectable, ViewEncapsulation} from '@angular/core';
import { MatLegacySnackBar as MatSnackBar, MatLegacySnackBarConfig as MatSnackBarConfig } from '@angular/material/legacy-snack-bar';

@Injectable()
export class SnackBarService {
  private config: MatSnackBarConfig;
  private encapsulation: ViewEncapsulation.None;
  constructor(private snackBar: MatSnackBar) {
    this.config = new MatSnackBarConfig();
    this.config.duration = 2000;
  }

  public open(message: string, duration?: number, action?: string) {
    this.config = duration ? Object.assign(this.config, {'duration': duration}) : this.config;
    this.snackBar.open(message, action, this.config);
  }
}
